// shadcn/ui textarea (CLI 4.21.0), rebound to docs/tokens.css.
import * as React from "react";
import { cn } from "@/lib/utils";

// forwardRef: React 18 (see button.tsx).
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentPropsWithoutRef<"textarea">>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          "flex min-h-24 w-full rounded-control border border-input bg-card px-3 py-2 text-body text-foreground outline-none transition-[border-color] placeholder:text-muted-foreground dark:bg-muted",
          "focus-visible:border-primary disabled:cursor-not-allowed disabled:bg-muted aria-invalid:border-destructive",
          className,
        )}
        {...props}
      />
    );
  },
);

export { Textarea };
